import type * as React from 'react';
import { Pagination } from '../../Form/Pagination';

interface ReportTableProps {
  headerValues: { label: string; value: string }[];
  rows: { toObject(): Record<string, any> }[];
  isLoading: boolean;
  limit: number;
  offset: number;
  total: number;
  onPageChange: (offset: number) => void;
}

export const ReportTable: React.FC<ReportTableProps> = ({
  headerValues,
  rows,
  isLoading,
  limit,
  offset,
  total,
  onPageChange,
}) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          {isLoading ? (
            <>
              <i className="far fa-spinner fa-spin"></i> Loading...
            </>
          ) : rows.length > 0 ? (
            <>
              <div>Total: {total}</div>
              <table className="table table-sm table-borderless header-fixed dataTable no-footer">
                <thead>
                  <tr>
                    {headerValues.map((col) => (
                      <th key={col.value}>{col.label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, rowIndex) => {
                    const rowData = row.toObject();

                    return (
                      <tr className="border-bottom" key={rowIndex}>
                        {Object.values(rowData).map((val, colIndex) => (
                          <td key={colIndex}>{val ?? ''}</td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          ) : (
            <div className="text-muted">No results.</div>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-12 text-right">
          <Pagination limit={limit} offset={offset} total={total} onPageChange={onPageChange} />
        </div>
      </div>
    </>
  );
};
